import { createFileRoute, redirect } from "@tanstack/react-router"
import { shouldRouteDashboardHostToCms } from "@utils/dashboard-host"
import { currentRequestHostname } from "@utils/dashboard-host-runtime"

export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    if (shouldRouteDashboardHostToCms(await currentRequestHostname(), "/")) {
      throw redirect({ href: "/dashboard" })
    }
    throw redirect({ href: "/ja" })
  },
})
